import {Action} from '@ngrx/store';
import {Timezone} from '../models/timezone';
import {type} from '../utilities/type';

export const timezonesActionTypes = {
  LOAD: type('[Timezones] Load'),
  LOAD_SUCCESS: type('[Timezones] Load Success'),
  LOAD_FAIL: type('[Timezones] Load Fail'),
  UPDATE: type('[Timezones] Update'),
  CLEAR: type('[Timezones] Clear')
};

export class LoadTimezonesAction implements Action {
  readonly type = timezonesActionTypes.LOAD;
  constructor() {}
}

export class LoadTimezonesSuccessAction implements Action {
  readonly type = timezonesActionTypes.LOAD_SUCCESS;
  constructor(public payload?: Timezone[]) {}
}

export class LoadTimezonesFailAction implements Action {
  readonly type = timezonesActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
export class UpdateTimezonesSuccessAction implements Action {
  readonly type = timezonesActionTypes.UPDATE;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any[]) {}
}
export class ClearTimezonesSuccessAction implements Action {
  readonly type = timezonesActionTypes.CLEAR;
  constructor() {}
}
